import uuid from '../../../utils/uuid';
import templateConstants from '../../template/constants';

const generatePageSource = (name, locale) => {
  if (locale === templateConstants.DEFAULT_TEMPLATE_LOCALE) {
    return `/${name}.html`;
  }
  return `/${locale}/${name}.html`;
};

const createPageSource = (pages, locale) => {
  let pageSourceName = '';
  let shouldGenerateSource = true;

  while (shouldGenerateSource) {
    pageSourceName = generatePageSource(uuid(), locale);

    // eslint-disable-next-line no-loop-func
    shouldGenerateSource = pages.some((page) => page.source === pageSourceName);
  }

  return pageSourceName;
};

export default createPageSource;
